<div class="top-part">
  <img
    class="size-30 md:size-20 mr-2.5 md:mr-5 rounded"
    [src]="imgUrl$ | async"
    alt="img track"
  />
  <div class="actions relative">
    <div
      class="buttons flex-col gap-2 md:flex-row justify-center w-full"
      [class.flex-1]="(onMobile$ | async) && hasCustomCover()"
    >
      <input
        #basicfileinput
        type="file"
        [accept]="accept"
        multiple="false"
        (change)="onFileSelect($event)"
        class="input-file"
      />
      <rk-button
        class="w-full md:flex-1"
        btnStyle="orange"
        faIcon="fa-camera"
        [label]="'MEDIA.EDIT_TRACK.EDIT_COVER' | translate"
        [fullWidth]="true"
        [loading]="loading$ | async"
        (click)="onClickAddFiles()"
      ></rk-button>
      <rk-button
        *ngIf="!isMultiple && !(onMobile$ | async)"
        btnStyle="orange"
        [svgIcon]="'dot-down'"
        [matMenuTriggerFor]="menuImage"
        [disabled]="loading$ | async"
      ></rk-button>
      <rk-button
        class="w-full md:hidden"
        *ngIf="hasCustomCover()"
        [label]="'MEDIA.EDIT_TRACK.DELETE_COVER' | translate"
        [fullWidth]="true"
        (click)="onDeleteFile()"
      ></rk-button>
    </div>
    <div class="errors h-0">
      <rk-form-error
        *ngIf="errors.fileToSmall"
        [classes]="'mt-4'"
        [errorMessage]="
          'SETTINGS.FORM.IMAGE_UPLOAD.ERROR.TOO_SMALL'
            | translate: { minHeight: minHeight, minWidth: minWidth }
        "
      ></rk-form-error>
      <rk-form-error
        *ngIf="errors.maxFileSize"
        [classes]="'mt-4'"
        [errorMessage]="
          'SETTINGS.FORM.IMAGE_UPLOAD.ERROR.TOO_BIG' | translate: { size: maxFileMb() }
        "
      ></rk-form-error>
      <rk-form-error
        *ngIf="errors.invalidFileType"
        [classes]="'mt-4'"
        [errorMessage]="'SETTINGS.FORM.IMAGE_UPLOAD.ERROR.FILE_TYPE' | translate"
      ></rk-form-error>
    </div>
  </div>
</div>

<mat-menu #menuImage="matMenu" [overlapTrigger]="false">
  <button mat-menu-item (click)="onLookupFile()">
    <mat-icon fontSet="fa" fontIcon="fa-image"></mat-icon>
    <span translate>MEDIA.EDIT_TRACK.SEARCH_COVER</span>
  </button>
  <div class="menu-separator" *ngIf="hasCustomCover()"></div>
  <button mat-menu-item (click)="onDeleteFile()" *ngIf="hasCustomCover()">
    <mat-icon fontSet="fa" fontIcon="fa-trash"></mat-icon>
    <span translate>MEDIA.EDIT_TRACK.DELETE_COVER</span>
  </button>
</mat-menu>
